<template>
  <div>
    <el-breadcrumb separator="/" style="padding-bottom: 10px;">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单商品</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="top-query">
      <el-form ref="queryData" :model="queryData" label-width="100px" size="mini">

        <el-form-item label="产品名称" style="width: 520px;">
          <el-input placeholder="请输入产品名称" v-model="queryData.productName"></el-input>
        </el-form-item>
        <el-form-item label="影院名称" style="width: 520px;">
          <el-input placeholder="影院名称" v-model="queryData.company"></el-input>
        </el-form-item>

        <el-form-item label="订单状态">
          <el-radio-group v-model="queryData.orderState">
            <el-radio :label="100">待审核</el-radio>
            <el-radio :label="101">IMAX已审核</el-radio>
            <el-radio :label="102">已支付</el-radio>
            <el-radio :label="209">开始生产</el-radio>
            <el-radio :label="210">已发货</el-radio>
            <el-radio :label="212">已付款,支付已确认</el-radio>
            <el-radio :label="211">已开票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker v-model="queryData.data" style="width:420px" type="daterange"
                          :default-time="['00:00:00', '23:59:59']"
                          value-format="yyyy-MM-dd HH:mm:ss" align="right"
                          unlink-panels range-separator="至" start-placeholder="开始日期"
                          end-placeholder="结束时间">
          </el-date-picker>
        </el-form-item>

        <!-- 下面是查询按钮 -->
        <el-form-item style="float: right;">
          <el-button type="success" @click="exportOrderProduct" size="mini" icon="el-icon-folder-opened" plain>导出
          </el-button>

          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div v-if="statisticsStatus=='true'" style="margin: 10px 30px;"><span>下单数：</span>
        <span
            id="orders">{{ orderData.orders }}</span>
        <span> 张</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>总金额：</span>
        <span
            id="amount">{{ orderData.amount }}</span>
        <span> ¥</span></div>
    </div>

    <div class="table">
      <el-table stripe height="800"  :data="tableData" border style="width: 100%">
        <el-table-column fixed prop="orderId" label="订单ID" width="150">
        </el-table-column>

        <el-table-column prop="companyName" label="影城名称" width="280">
        </el-table-column>

        <el-table-column prop="productName" label="产品名称" width="200">
        </el-table-column>

        <el-table-column label="商品图片" width="120">
          <template slot-scope="scope">
            <ImageCarousel :images="scope.row.imageUrls.split(',')"
                           :show-index="false"
                           :buttonVisible="false"
                           class="product-image" style="width: 100px; height: 100px;" />
          </template>
        </el-table-column>

        <el-table-column prop="productPrice" label="产品单价" width="120">
          <template slot-scope="scope">
            {{scope.row.productPrice}} ￥
          </template>
        </el-table-column>

        <el-table-column prop="orderCount" label="购买数量" width="120">
          <template slot-scope="scope">
            {{scope.row.orderCount}} 件
          </template>
        </el-table-column>

        <el-table-column prop="amount" label="购买金额" width="120">
          <template slot-scope="scope">
            {{scope.row.amount}} ￥
          </template>
        </el-table-column>

        <el-table-column prop="createOrderTime" label="下单时间" width="180">
        </el-table-column>

        <el-table-column prop="orderAmount" label="订单金额" width="120">
          <template slot-scope="scope">
            {{scope.row.orderAmount}} ￥
          </template>
        </el-table-column>

        <el-table-column prop="orderStateStr" label="订单状态" width="120">
        </el-table-column>

        <el-table-column prop="addressName" label="收件人" width="120">
        </el-table-column>

        <el-table-column prop="addressPhone" label="收件手机号" width="120">
        </el-table-column>

        <el-table-column prop="address" label="收件地址" width="350">
        </el-table-column>

        <el-table-column prop="expressNo" label="快递单号" width="150">
        </el-table-column>

        <el-table-column prop="expressCompany" label="快递公司" width="120">
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
<!--          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button type="text" size="small">编辑</el-button>
          </template>-->
        </el-table-column>

      </el-table>
    </div>
    <div class="bottom">
      <el-pagination @size-change="handleSizeChange" @current-change="changePage"
                     :current-page="queryData.pageNo"
                     :page-sizes="[15, 25, 40, 50]" :page-size="queryData.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total" style="float: right;">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import {
  orderProduct, orderProductStatistics
} from "../../request/api.js";
import ImageCarousel from "@/components/ImageCarousel.vue";
import axios from "axios";
import moment from "moment/moment";

export default {
  name: "OrderProduct",
  components: {ImageCarousel},
  data() {
    return {
      statisticsStatus: window.sessionStorage.getItem("statisticsStatus"),

      tableData:[],
      total:1,

      queryData: {
        orderState: null, //订单状态
        productName: null,
        orderName: null,
        company: null,
        data: [this.getTime(30),  this.getTime(-1)],
        startTime: "",
        endTime: "",
        pageNo: 1,
        size: 15,
      },

      orderData: {
        orders: 0,
        amount: 0
      },
    }
  },

  methods: {
    handleClick() {

    },

    getTime(day) {
      const date = new Date();
      date.setTime(date.getTime() - day  * 24 * 60 * 60 * 1000)
      return date;
    },

    orderList() {
      this.queryData.startTime = moment(String(this.queryData.data[0])).format('YYYY-MM-DD HH:mm:ss');
      this.queryData.endTime = moment(String(this.queryData.data[1])).format('YYYY-MM-DD HH:mm:ss');
      let queryDataForm = this.queryData;
      orderProduct(queryDataForm).then((data) => {
        this.tableData = data.data.list;
        this.total = data.data.total;
      })
    },

    orderStatistics() {
      let queryDataForm = this.queryData;
      orderProductStatistics(queryDataForm).then((data) => {
        if (data.data === undefined || data.data === null) {
          document.getElementById('amount').innerHTML = "0";
          document.getElementById('orders').innerHTML = "0";
        }
        console.log("tongjineio.............", data.data.totalAmount)
        this.orderData.amount = data.data.totalAmount;
        this.orderData.orders = data.data.productCount;
        document.getElementById('amount').innerHTML = data.data.totalAmount;
        document.getElementById('orders').innerHTML = data.data.productCount;
      })
    },

    exportOrderProduct() {
      axios.post('/movie/v2/order/product/export', this.queryData, {
        responseType: 'blob', // 重要！告诉 axios 服务器返回的是文件流
      }).then(res =>{
        if(res.status == 200) {
          // 创建 Blob 对象并触发下载
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
          // 创建下载链接
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = '订单商品信息.xls'; // 设置下载文件的名字

          // 触发点击事件，开始下载
          link.click();
          // 释放 Blob 对象
          URL.revokeObjectURL(link.href);
        }
      });
    },

    onSubmit() {
      if (!this.queryData.data) {
        console.log('data数组为空');
        this.queryData.startTime = null;
        this.queryData.endTime = null;
      } else {
        this.queryData.startTime = moment(String(this.queryData.data[0])).format('YYYY-MM-DD HH:mm:ss');
        this.queryData.endTime = moment(String(this.queryData.data[1])).format('YYYY-MM-DD HH:mm:ss');
      }

      let queryDataForm = this.queryData;
      orderProduct(queryDataForm).then((data) => {
        this.tableData = data.data.list;
        this.total = data.data.total;
      });

      if(this.statisticsStatus =='true'){
        this.orderStatistics();
      }
    },

    reset() {
      this.queryData.orderState = null;
      this.queryData.productName = null;
      this.queryData.company = null;
      this.queryData.data = [];
      this.queryData.startTime = null;
      this.queryData.endTime = null;
    },

    handleSizeChange(a) {
      this.queryData.size = a;
      this.orderList()
    },
    changePage(page) {
      this.queryData.pageNo = page;
      this.orderList()
    },


  },

  created() {
    this.orderList();
    if (this.statisticsStatus == "true") {
      this.orderStatistics();
    }
  }

}

</script>